import http from '../interceptors/Intercepter';

export const createPerson = async (username, personVOToCreate) => {
  try {
    const { data } = await http.post('/api/person/create', { username, personVOToCreate });
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveAllPersons = async (username) => {
  try {
    const { data } = await http.get('/api/person/viewAll?username=' + username);
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveAllSystemUserPersons = async (username) => {
  try {
    const { data } = await http.get('/api/person/viewAll/system-user?username=' + username);
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrievePersonById = async (username, idNumber) => {
  try {
    const params = { username, idNumber };

    const { data } = await http.get('/api/person/view/from-id-number', { params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewStaffForStudy = async (username, requestData) => {
  try {
    const params = { username };

    const { data } = await http.post('/api/person/view/staff-for-study', requestData, { params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
